<template>
  <div class="video-page-wrapper">
    <IphoneVideo :video-name="require('@/assets/videos/lighting.mp4')"></IphoneVideo>
    <PageTabs>
      <template v-slot:first>
        <div class="page-tabs-margin-top-lg">
          <h3>{{ $t("pages.lighting.subtitle1") }}</h3>
          <p>{{ $t("pages.lighting.text1") }}</p>
        </div>
      </template>
      <template v-slot:second>
        <VoiceCommands :commands="commands"></VoiceCommands>
      </template>
    </PageTabs>

  </div>
</template>

<script>
import PageTabs from "../components/PageTabs";
import VoiceCommands from "../components/VoiceCommands";
export default {
  name: "Lighting",
  components: {VoiceCommands, PageTabs },
  data() {
    return {
      commands: this.$t("pages.lighting.commands")
    };
  }
};
</script>
